import { useNavigate } from 'react-router-dom'

import { allSettingsSections } from '../../routes/settingsRoutes'
import SectionSettingsList from '../settings/SectionSettingsList'

function SettingsFilesPage() {
  const navigate = useNavigate()
  const { label, subsections } = allSettingsSections.files

  const handleSelectSetting = setting => navigate(subsections[setting].path)

  return <SectionSettingsList sectionLabel={label} settings={subsections} handleSelectSetting={handleSelectSetting} />
}

export default SettingsFilesPage
